export default function Favourites(config) {
    this.container = null;
    this.toggleLink = null;
    this.texts = {
        created: null,
        deleted: null,
        error: null,
    };

    this.setConfig(config);
    this.validate();

    this.bindEvent();
}

Favourites.defaults = {
    container: null,
    toggleLink: null,
    texts: {
        created: null,
        deleted: null,
        error: null,
    },
};

Favourites.prototype.validate = function () {
    if (!this.container) {
        throw new Error('Container must be specified as key "container"');
    }

    if (!this.toggleLink) {
        throw new Error('Favourite toggle link must be specified as key "toggleLink"');
    }

    if (!this.texts.created || !this.texts.created || !this.texts.error) {
        throw new Error('Created and deleted notifications have to be specified');
    }

    if (!this.texts.created || !this.texts.created) {
        throw new Error('Generic error message has to be specified');
    }
};

Favourites.prototype.setConfig = function (given) {
    let config = {...Favourites.defaults};

    Object.keys(given).forEach(function (key) {
        if (config.hasOwnProperty(key)) {
            config[key] = given[key];
        }
    });

    Object.assign(this, config);
};

Favourites.prototype.bindEvent = function () {
    const that = this;

    this.container.addEventListener('click', async function (event) {
        await that.onToggleClick(event);
    });
};

Favourites.prototype.onToggleClick = async function (event) {
    if (event.target.classList.contains('toggle-favourite__button')) {
        event.preventDefault();

        await this.toggleFavourite(event.target);
    }
}

Favourites.prototype.toggleFavourite = async function (eventTarget) {
    eventTarget.classList.add('loading');

    await this.makeToggleFavouriteRequest(
        eventTarget,
        !eventTarget.classList.contains('selected')
    );

    eventTarget.classList.remove('loading');
}

Favourites.prototype.makeToggleFavouriteRequest = async function (eventTarget, create) {
    axios.post(this.toggleLink, {
        itemId: eventTarget.getAttribute('data-item-id'),
        action: create ? 'create' : 'delete'
    })
        .then((response) => {
            if (response.data.status === 200) {
                if (create) {
                    eventTarget.classList.add('selected');
                    eventTarget.setAttribute('data-current_state', 'on');

                    Notifications.notify(eventTarget.getAttribute('data-title') + ' ' + this.texts.created);
                } else {
                    eventTarget.classList.remove('selected');
                    eventTarget.setAttribute('data-current_state', 'off');

                    Notifications.notify(eventTarget.getAttribute('data-title') + ' ' + this.texts.deleted);
                }
            } else {
                Notifications.notify(this.texts.error);
            }
        })
        .catch((error) => {
            this.handleError(error);
        });
}

Favourites.prototype.handleError = function (error) {
    if (error.response.status === 419) {
        location.reload();
    } else {
        Notifications.notify(this.texts.error);
    }
}
